<template>
  <div class="compressed-content">
    <h3>What is your most recent blood pressure?</h3>
    <div class="page-buttons">
      <v-form-group :validator="$v.systolic" label="Systolic (top number)">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.bloodPressure.systolic"
                      placeholder="Blood pressure"
                      @click="e => e.target.setSelectionRange(0, e.target.value.length)" />
      </v-form-group>
      <v-form-group :validator="$v.diastolic"
                    :messages="{ maxValue: 'Uh oh. It looks like you may have switched your blood pressure numbers. Your Systolic (top number) is always going to be higher than your Diastolic (bottom number).' }"
                    label="Diastolic (bottom number)"
      >
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.bloodPressure.diastolic"
                      placeholder="Blood pressure"
                      @click="e => e.target.setSelectionRange(0, e.target.value.length)" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, maxValue } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import productType from 'enums/product-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        productType
      }
    },

    validations() {
      return {
        systolic: {
          required,
          between: between(50, 250)
        },
        diastolic: {
          required,
          between: between(50, 150),
          maxValue: maxValue(this.systolic),
        }
      }
    },

    computed: {
      ...mapState(["survey"]),

      systolic() { return this.survey.bloodPressure.systolic; },
      diastolic() { return this.survey.bloodPressure.diastolic; }
    }
  };
</script>
